<template>
    <dash
        icon="fa fa-user-plus"
        titulo="SOLICITAÇÕES DE ACESSO NO ANO"
        :loading="loading"
        color="#E59500"
    >
        {{ qtd.total }}
        <span class="h3">
            <i class="fa fa-users text-info mr-2" title="Total"></i>
        </span>
        <span class="text-muted h3">|</span>
        {{ qtd.aprovadas }}
        <span class="h3">
            <i class="fa fa-thumbs-o-up text-success mr-2" title="Aprovadas"></i>
        </span>
        <span class="text-muted h3">|</span>
        {{ qtd.reprovadas }}
        <span class="h3">
            <i class="fa fa-thumbs-o-down text-danger" title="Reprovadas"></i>
        </span>
    </dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent2'

export default {
	props: {
		qtd: {
			type: Object
		},

		loading: {
			type: Boolean
		}
	},

	components: {
		Dash
	},

	data() {
		return {}
	}
}
</script>
